import {toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"

const config = {
    headers: {
        // "Accept": "*/*",
        // "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    }
}

const eshopopeeApi = {
    //查詢商家信息
    "getCompanyEndDates": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/controlcenter/backend/Customer/getCompanyEndDates.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCodes: null //acccompanycode
            }
        }
    },
    //下架產品
    "takeDownMaterial": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/product/offAndOnShelf.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCodes: null, //acccompanycode
                ProductID: null,
                hiding: 1
            }
        }
    },
    //上傳產品
    "uploadProduct": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/uploadProduct.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                type1: null,
                type2: null,
                type3: null,
                shopopeeCompanyCode: null,
                memberID: null,  //login
                productCompanyCode: null,//e-shopopee公司編號
                productName: null,
                productName2: null,
                description: null,
                description2: null,
                cost: null,
                purchaseCost: 0,
                pt1: null,
                pt12: null,
                pt2: null,
                pt22: null,
                unit: null,
                curr: null,
                imgdata: null,
            }
        }
    },
    //獲取公司付款方式
    "getPaymentList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/payment/getData.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //acccompanycode
            }
        }
    },
    //添加付款方式
    "insertPayment": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/payment/save.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                paymentTitle: null,
                paymentSubTitle: null,
                sremark: null,
                paymentMethod: null,
                accountLogin: null,
                handlePercent: null,
                CompanyCode: null, //acccompanycode
                QRImg: null
            }
        }
    },
    //修改付款方式
    "updatePayment": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/payment/save.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                handlePercent: null,
                paymentMethod: null,
                paymentTitle: null,
                customerTypeStr: null,
                accountLogin: null,
                sremark: null,
                paymentSubTitle: null,
                paymentID: null,
                CompanyCode: null,  //acccompanycode
                QRImg: null
            }
        }
    },
    //刪除付款方式
    "delPayment": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/payment/del.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                paymentID: null,
                CompanyCode: null  //acccompanycode
            }
        }
    },
    //獲取公司運輸方式
    "getDeliveryList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/delivery/get.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companyCode: null  //acccompanycode
            }
        }
    },
    //添加運輸方式
    "insertDelivery": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/delivery/save.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                deliveryCompanyCode: null,  //acccompanycode
                PTD: null,
                PTD2: null,
                Cost: null,
                ProcedureType: 7,
                NatureID: "Delivery",
                CustomerTypeStr: "All",
                settingList: [  //转为json字符串发送
                    {
                        CompanyCode: null,  //eshopopee公司代码
                        DeliveryCode: "De7",
                        CountryCode: "", //地区代码
                        Unit: null, //货币单位
                        Curr: null, //货币单位
                        DeliveryFee: null //运费
                    }
                ]
            }
        }
    },
    //修改運輸方式
    "updateDelivery": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/delivery/save.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                deliveryCompanyCode: null,  //acccompanycode
                PTD: null,
                PTD2: null,
                Cost: null,
                productID: null,
                settingList: []  //转为json字符串发送
            }
        }
    },
    "getBOCount": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/getBOCount.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //acccompanycode
            }
        }
    },
    "getBOAll": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/getBOAll.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //acccompanycode
            }
        }
    },
    "updateBOState": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/updateBOState.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //acccompanycode
                CommonRef: null, //acccompanycode
                Verify: null, //acccompanycode
            }
        }
    },
    "updatePaymentState": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/updatePaymentState.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //acccompanycode
                CommonRef: null, //acccompanycode
                Verify: null, //acccompanycode
            }
        }
    },
    "getBODayCount": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/getBODayCount.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //acccompanycode
                month:''
            }
        }
    },
    //刪除運輸方式
    "delDelivery": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/delivery/del.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companyCode: null,  //acccompanycode
                productID: null,
            }
        }
    },
    //開通店鋪
    "openShop": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/CompanyJudge.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                password: null,
                days: 31,
                countrycode: null,
                Curr: null,
                proxypay: null
            }
        }
    },
    //添加單位
    "insertUnit": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/unit/save.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null,  //EShopopee公司代碼
                unitCode: null,  //單位代碼
                description: null, //單位中文名稱
                description2: null, //單位英文名稱
            }
        }
    },
    //修改單位
    "updateUnit": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/unit/update.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,  //單位id
                CompanyCode: null,  //EShopopee公司代碼
                unitCode: null,  //單位代碼
                description: null, //單位中文名稱
                description2: null, //單位英文名稱
            }
        }
    },
    //查詢單位
    "getUnit": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/unit/get.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null,  //EShopopee公司代碼
            }
        }
    },
    //刪除單位
    "delUnit": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/unit/del.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null, //單位id
                CompanyCode: null,  //EShopopee公司代碼
            }
        }
    },
    //刪除產品
    "delProduct": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/del.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                delProductID: null, //產品id
                CompanyCode: null,  //EShopopee公司代碼
            }
        }
    },
    //修改產品
    "updateProduct": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/update.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null,  //EShopopee公司代碼
                ProductID: null,   //產品id
                ProductName: null,  //產品名稱
                ProductName2: null,  //產品英文名稱
                Description: null,  //產品描述
                Description2: null,  //產品英文描述
                Cost: null,  //產品價格
                Unit: null,  //產品單位id
                imgData: null,  //產品圖片
                pt1: null,  //產品二級類別名稱
                pt12: null,  //產品二級類別英文名稱
                pt2: null,  //產品三級類別名稱
                pt22: null,  //產品三級類別英文名稱
            }
        }
    },
    //獲取產品的批發價
    "getMaterialWholesale": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/getClientProSerQty.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                productid: null, //產品id
                companycode: null,  //EShopopee公司代碼
            }
        }
    },
    //修改產品的批發價
    "saveMaterialWholesale": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/saveClientProSerQty.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                productid: null, //產品id
                companycode: null,  //EShopopee公司代碼
                dataList: [  //轉換為json字符串發送
                    {
                        BiggerThan: null,  //最低購買量
                        Country: null,  //地區代碼
                        Cost: null  //價格
                    }
                ]
            }
        }
    },
    //刪除產品的批發價
    "delMaterialWholesale": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/delClientProSerQty.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null, //要刪除的id
            }
        }
    },
    //查询报价单的详细信息
    "getQuotationRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/quotation/getQuotationRecord.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                ref: null, //报价单编号
                companycode: null, //商家公司代码
            }
        }
    },
    //查询運輸備註
    "getDeliverynameRecordList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/deliveryname/getDeliveryNameList.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //E-shopopee商家公司代码
            }
        }
    },
    //添加運輸備註
    "addDeliverynameRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/deliveryname/saveDeliveryName.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null, //E-shopopee商家公司代码
                ShipmentAddress: null,  //中文描述
                ShipmentAddressCN: null,  //英文描述
                District1: null  //地區代碼
            }
        }
    },
    //修改運輸備註
    "updateDeliverynameRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/deliveryname/saveDeliveryName.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                ShipmentAddress: null,  //中文描述
                ShipmentAddressCN: null,  //英文描述
                District1: null  //地區代碼
            }
        }
    },
    //刪除運輸備註
    "delDeliverynameRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/deliveryname/delDeliveryName.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
            }
        }
    },
    //查询产品列表的批发价
    "getClientProSerQty": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/getClientProSerQty.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,  //eshopopee的companycode
                idList: null  //产品id以逗号隔开
            }
        }
    },
    //查詢產品的報價信息
    "getMateriaListByQtyIDList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/getMateriaListByQtyIDList.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,  //eshopopee的companycode
                idList: null,  //批發價d以逗号隔开
                productIDList: null,  //產品id以逗號隔開
                countrycode: null  //用戶的地區代碼
            }
        }
    },
    //提交報價單
    "submitQuotation": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/Web/W006/api/shopopee/Quotation/save.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                ShopopeeLogin: null,
                ShopopeePassword: null,
                // PaymentMethodAmount: null,
                // paymentMethodId: null,
                CompanyCode: null,  //EShopopee公司代碼
                productID: null,
                qty: null,
                unit: null,
                price: null,
                clientLink: "",
                clientCompanyCode: "",
                InternationalAddress: "",
                address: "",
                DeliveryPID: null,
                DeliveryPrice: null,
                deliveryRemark: "",
                //是否開啟生態
                useAuto: -1
            }
        }
    },
    //獲取用戶的所有報價單列表
    "getAllQuotationList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/quotation/getAllQuotationList.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,  //用戶登錄
            }
        }
    },
    //修改支付方式狀態
    "changeSetting": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/setting/changeSetting.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CCCompanyCode: null,
                functionStr: "AGP01",  //標識字段
                functionValue: null
            }
        }
    },
    //查詢支付方式狀態
    "getSetting": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/setting/getSetting.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CCCompanyCode: null,
                functionStr: "AGP01",  //標識字段
            }
        }
    },
    //查看下token
    "gethash512": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/hash512.php`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                amount:null,
            }
        }
    },
    "getAIChatState": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/getAIChatState.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode:null,
                Login:"",
            }
        }
    },
    //獲取產品優惠券
    "getProductCouPonsList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/getCouponsMaterialList.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companyCode: null,  //acccompanycode
                PromoProductID: null  //綁定產品
            }
        }
    },
    //獲取產品優惠券
    "updateProductCouPons": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/updateCouponsMaterial.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companyCode: null,  //acccompanycode
                PromoProductID: null  //綁定產品
            }
        }
    },
    //刪除產品優惠券
    "delCouponsMaterial": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.SSL}://${baseUrl.eshopopee}/ControlCenter/api/shopopee/product/delCouponsMaterial.asp`, data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companyCode: null,  //acccompanycode
                PromoProductID: null  //綁定產品
            }
        }
    },
}

export default eshopopeeApi